import { render, staticRenderFns } from "./dashboards.vue?vue&type=template&id=366b1052&"
import script from "./dashboards.vue?vue&type=script&lang=js&"
export * from "./dashboards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports